<template>
  <div class="flex h-screen bg-white">
    <!-- Main Sidebar -->
    <Sidebar
      v-if="showMainSidebar"
      @calendar="showCalendarSidebar"
      class="flex-shrink-0"
    />

    <!-- Admin Sidebar -->
    <AdminSidebar
      v-if="$route.path.startsWith('/admin')"
      class="flex-shrink-0"
    />

        <!-- Calendar Sidebar -->
        <CalendarSidebar
            v-if="isCalendarVisible && ($route.path === '/calendar' || $route.path === '/settings' || $route.path === '/content-library' || $route.path === '/analytics')"
            @calendar="navigateToCalendar" @settings="navigateToSettings" @content-library="navigateToContentLibrary"
            @analytics="navigateToAnalytics" @platform-selected="onPlatformSelected" class="flex-shrink-0" />

        <!-- Main Content -->
        <div class="flex-1 overflow-auto flex flex-col">
            <!-- Trial Counter Header - Only show if not on subscription page and subscription is not active -->
            <TrialCounter 
                v-if="$route.path !== '/welcome' && 
                      !$route.path.includes('/help/') && 
                      $route.path !== '/subscription' &&
                      !$route.path.startsWith('/admin')" 
                ref="trialCounter" 
            />
            <div class="w-full flex-1">
                <router-view v-slot="{ Component }">
                    <component :is="Component" v-if="$route.path === '/calendar'" :platform="selectedPlatform" />
                    <component :is="Component" v-else />
                </router-view>
            </div>
        </div>
    </div>
</template>

<script>
import Sidebar from './Sidebar.vue'
import AdminSidebar from './AdminSidebar.vue'
import CalendarSidebar from './CalendarSidebar.vue'
import TrialCounter from './TrialCounter.vue'

export default {
    name: 'MainLayout',
    components: {
        Sidebar,
        AdminSidebar,
        CalendarSidebar,
        TrialCounter
    },
    data() {
        return {
            isCalendarVisible: false,
            selectedPlatform: 'all'
        }
    },
    created() {
        // Show calendar sidebar if on calendar, settings, or content library page
        if (this.$route.path === '/calendar' ||
            this.$route.path === '/settings' ||
            this.$route.path === '/content-library' ||
            this.$route.path === '/analytics') {
            this.isCalendarVisible = true
        }
    },
    watch: {
        '$route'(to) {
            // Hide calendar sidebar when navigating away from calendar, settings, or content library
            if (to.path !== '/calendar' && to.path !== '/settings' && to.path !== '/content-library' && to.path !== '/analytics') {
                this.isCalendarVisible = false
            } else {
                this.isCalendarVisible = true
            }
            
            // Refresh trial counter when route changes (e.g., after payment)
            this.$nextTick(() => {
                if (this.$refs.trialCounter) {
                    this.$refs.trialCounter.fetchTrialStatus();
                }
            });
        }
    },
    methods: {
        showCalendarSidebar() {
            this.isCalendarVisible = true
            this.navigateToCalendar()
        },
        navigateToCalendar() {
            this.$router.push('/calendar')
        },
        navigateToSettings() {
            this.$router.push('/settings')
        },
        navigateToContentLibrary() {
            this.$router.push('/content-library')
        },
        navigateToAnalytics() {
            this.$router.push('/analytics')
        },
        onPlatformSelected(platform) {
            this.selectedPlatform = platform;
        }
    },
    computed: {
        showMainSidebar() {
            const path = this.$route.path;
            const noSidebarPaths = [
                '/welcome',
            ];
            
            if (noSidebarPaths.includes(path)) return false;
            if (path.includes('/help/')) return false;
            if (path.startsWith('/admin')) return false;
            
            return true;
        },
        isAdmin() {
            const creatorStr = localStorage.getItem('creator');
            if (creatorStr) {
                try {
                    const creator = JSON.parse(creatorStr);
                    const role = creator.role || creator._doc?.role;
                    return role === 'admin';
                } catch (e) {
                    return false;
                }
            }
            return false;
        }
    }
}
</script>